import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, Modal, Button, Image } from "react-bootstrap";
import Select from "react-select";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { base64ToBlob } from "utils/HelperFunction";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CircleIcon from "@mui/icons-material/Circle";
import { Stack } from "@mui/material";
import { ModalAllder } from "layouts/ModalAllder";
import { clearCreateNewProduct, createNewProduct } from "../../redux/handlers/logic/createNewProduct.handler";
import { clearUpdateProduct, updateProduct } from "../../redux/handlers/logic/updateProduct.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllChannelOffline } from "../../redux/handlers/master/getAllChannelOffline.handler";
import { getAllChannelOnline } from "../../redux/handlers/master/getAllChannelOnline.handler";
import { getAllMstUnit } from "../../redux/handlers/master/getAllMstUnit.handler";
import { getEvidenceType } from "../../redux/handlers/master/getEvidenceType.handler";
import { getProductType } from "../../redux/handlers/master/getProductType.handler";
import { getCategory } from "../../redux/handlers/master/getCategory.handler";
import { getSubCategory } from "../../redux/handlers/master/getSubCategory.handler";
import { getAllMstUnitWeight } from "../../redux/handlers/master/getAllMstUnitWeight.handler";
import { getAllDimension } from "../../redux/handlers/master/getAllDimension.handler";
import { getAllProductFileType } from "../../redux/handlers/master/getAllProductFileType.handler";
import { getProductDetail } from "../../redux/handlers/logic/getProductDetail.handler";
import { updateComment } from "../../redux/handlers/logic/updateComment.handler";
import { uploadProduct } from "../../redux/handlers/logic/uploadProduct.handler";
import axios from "axios";
import dayjs from "dayjs";
import { createComment, clearcreateComment } from "../../redux/handlers/logic/createComment.handler";
import moment from "moment";
export function ProductNormal() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var businessID = null;
    var memID = null;
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member, _payload_member1;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    businessID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.bus_business_id) || null;
                    memID = parseInt((_payload_member1 = payload.member) === null || _payload_member1 === void 0 ? void 0 : _payload_member1.mb_mem_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var _useState = _sliced_to_array(useState(false), 2), modalcancel = _useState[0], setModalcancel = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), modalsuccess = _useState1[0], setModalsuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), textsuccess = _useState2[0], setTextsuccess = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), formdisabled = _useState3[0], setFormdisabled = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loadRow = _useState4[0], setLoadRow = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionsOffline = _useState5[0], setOptionsOffline = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionsOnline = _useState6[0], setOptionsOnline = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsUnit = _useState7[0], setOptionsUnit = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), evidenceType = _useState8[0], setEvidenceType = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionsType = _useState9[0], setOptionsType = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionsCate = _useState10[0], setOptionsCate = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), optionsSupCate = _useState11[0], setOptionsSupCate = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsUnitWeight = _useState12[0], setOptionsUnitWeight = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsDimension = _useState13[0], setOptionsDimension = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), valOffline = _useState14[0], setValOffline = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), valOnline = _useState15[0], setValOnline = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), valComment = _useState16[0], setValComment = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), optionsProductFile = _useState17[0], setOptionsProductFile = _useState17[1];
    var hasInputValue = function(value) {
        return value !== null && value !== undefined && value !== "";
    };
    var toNumberOrZero = function(value) {
        return hasInputValue(value) ? parseFloat(value) : 0;
    };
    var toIntOrZero = function(value) {
        return hasInputValue(value) ? parseInt(value, 10) : 0;
    };
    var calculateDetailGp = function(priceValue, recommentPriceValue) {
        var price = toNumberOrZero(priceValue);
        var recommentPrice = toNumberOrZero(recommentPriceValue);
        if (recommentPrice <= 0) {
            return 0;
        }
        return parseFloat(((recommentPrice - price) / recommentPrice * 100).toFixed(2));
    };
    var calculateProductGp = function(priceValue, recommentPriceValue) {
        var price = toNumberOrZero(priceValue);
        var recommentPrice = toNumberOrZero(recommentPriceValue);
        if (price <= 0) {
            return 0;
        }
        return parseFloat(((recommentPrice - price) / price * 100).toFixed(2));
    };
    var optionsVAt = [
        {
            label: "ไม่มี",
            value: 0
        },
        {
            label: "VAT 3%",
            value: 3
        },
        {
            label: "VAT 7%",
            value: 7
        },
        {
            label: "VAT 10%",
            value: 10
        }
    ];
    useEffect(function() {
        loadAllMsts();
    }, []);
    var loadAllMsts = function() {
        dispatch(getAllChannelOffline());
        dispatch(getAllChannelOnline());
        dispatch(getAllMstUnit());
        dispatch(getEvidenceType());
        dispatch(getProductType());
        dispatch(getAllMstUnitWeight());
        dispatch(getAllDimension());
        dispatch(getAllProductFileType());
        if (dataID) {
            dispatch(getProductDetail(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            setImgPath("");
        }
    };
    var getAllChannelOfflineReducer = useAppSelector(function(state) {
        return state.getAllChannelOfflineReducer;
    });
    var getAllChannelOnlineReducer = useAppSelector(function(state) {
        return state.getAllChannelOnlineReducer;
    });
    var getAllMstUnitReducer = useAppSelector(function(state) {
        return state.getAllMstUnitReducer;
    });
    var getEvidenceTypeReducer = useAppSelector(function(state) {
        return state.getEvidenceTypeReducer;
    });
    var getProductTypeReducer = useAppSelector(function(state) {
        return state.getProductTypeReducer;
    });
    var getCategoryReducer = useAppSelector(function(state) {
        return state.getCategoryReducer;
    });
    var getSubCategoryReducer = useAppSelector(function(state) {
        return state.getSubCategoryReducer;
    });
    var getAllMstUnitWeightReducer = useAppSelector(function(state) {
        return state.getAllMstUnitWeightReducer;
    });
    var createNewProductReducer = useAppSelector(function(state) {
        return state.createNewProductReducer;
    });
    var getAllDimensionReducer = useAppSelector(function(state) {
        return state.getAllDimensionReducer;
    });
    var getProductDetailReducer = useAppSelector(function(state) {
        return state.getProductDetailReducer;
    });
    var updateProductReducer = useAppSelector(function(state) {
        return state.updateProductReducer;
    });
    var updateCommentReducer = useAppSelector(function(state) {
        return state.updateCommentReducer;
    });
    var createCommentReducer = useAppSelector(function(state) {
        return state.createCommentReducer;
    });
    var getAllProductFileTypeReducer = useAppSelector(function(state) {
        return state.getAllProductFileTypeReducer;
    });
    useEffect(function() {
        setIsLoading(createNewProductReducer.isFetching);
        if (createNewProductReducer.data && !createNewProductReducer.isError) {
            setTextsuccess("เพิ่มสินค้าสำเร็จ");
            setModalsuccess(true);
            setFormdisabled(true);
            dispatch(clearCreateNewProduct());
            navigate("/product");
        }
    }, [
        createNewProductReducer
    ]);
    useEffect(function() {
        setIsLoading(updateProductReducer.isFetching);
        if (updateProductReducer.data && !updateProductReducer.isError) {
            setTextsuccess("แก้ไขสินค้าสำเร็จ");
            setModalsuccess(true);
            setFormdisabled(true);
            dispatch(clearUpdateProduct());
            navigate("/product");
        }
    }, [
        updateProductReducer
    ]);
    useEffect(function() {
        if (dataID) {
            setIsLoading(getProductDetailReducer.isFetching);
            if (getProductDetailReducer.data) {
                setFormData(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        pd_product_barcode: getProductDetailReducer.data.data[0].pd_product_barcode,
                        pd_product_brand: getProductDetailReducer.data.data[0].pd_product_brand != "null" ? getProductDetailReducer.data.data[0].pd_product_brand : "",
                        pd_product_businessid: getProductDetailReducer.data.data[0].pd_product_businessid,
                        pd_product_categoryid: getProductDetailReducer.data.data[0].pd_product_categoryid,
                        pd_product_categorysubid: getProductDetailReducer.data.data[0].pd_product_categorysubid,
                        pd_product_channelother: getProductDetailReducer.data.data[0].pd_product_channelother != "null" ? getProductDetailReducer.data.data[0].pd_product_channelother : "",
                        pd_product_code: getProductDetailReducer.data.data[0].pd_product_code,
                        // pd_product_dayexpire:
                        //   getProductDetailReducer.data.data[0].pd_product_dayexpire,
                        // pd_product_pddate: getProductDetailReducer.data.data[0]
                        //   .pd_product_pddate
                        //   ? moment(
                        //       getProductDetailReducer.data.data[0].pd_product_pddate
                        //     ).format("DD/MM/YYYY")
                        //   : "",
                        pd_product_detail: getProductDetailReducer.data.data[0].pd_product_detail != "null" ? getProductDetailReducer.data.data[0].pd_product_detail : "",
                        pd_product_dimensionid: //   getProductDetailReducer.data.data[0].pd_product_dimensionid,
                        // pd_product_evidence:
                        getProductDetailReducer.data.data[0].pd_product_evidence,
                        pd_product_evidencenumber: getProductDetailReducer.data.data[0].pd_product_evidencenumber,
                        // pd_product_evidencetypeid:
                        //   getProductDetailReducer.data.data[0].pd_product_evidencetypeid,
                        // pd_product_gp: getProductDetailReducer.data.data[0].pd_product_gp,
                        pd_product_high: getProductDetailReducer.data.data[0].pd_product_high,
                        pd_product_id: getProductDetailReducer.data.data[0].pd_product_id,
                        pd_product_long: getProductDetailReducer.data.data[0].pd_product_long,
                        pd_product_nameen: getProductDetailReducer.data.data[0].pd_product_nameen,
                        pd_product_nameth: getProductDetailReducer.data.data[0].pd_product_nameth,
                        // pd_product_price:
                        //   getProductDetailReducer.data.data[0].pd_product_price,
                        pd_product_producttypeid: getProductDetailReducer.data.data[0].pd_product_producttypeid,
                        // pd_product_recommentprice:
                        //   getProductDetailReducer.data.data[0].pd_product_recommentprice,
                        pd_product_unitid: getProductDetailReducer.data.data[0].pd_product_unitid,
                        pd_product_unitweightid: getProductDetailReducer.data.data[0].pd_product_unitweightid,
                        pd_product_vat: getProductDetailReducer.data.data[0].pd_product_vat,
                        pd_product_weight: getProductDetailReducer.data.data[0].pd_product_weight,
                        pd_product_wide: getProductDetailReducer.data.data[0].pd_product_wide,
                        pd_product_status: getProductDetailReducer.data.data[0].pd_product_status
                    });
                });
                var detail = [];
                if (getProductDetailReducer.data.data[0].PdPdetail) {
                    getProductDetailReducer.data.data[0].PdPdetail.map(function(ele) {
                        return detail.push(_object_spread_props(_object_spread({}, ele), {
                            id: nanoid(),
                            pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid == 0 ? "" : ele.pd_pdetail_dimensionid,
                            pd_pdetail_high: ele.pd_pdetail_high == 0 ? "" : ele.pd_pdetail_high,
                            pd_pdetail_long: ele.pd_pdetail_long == 0 ? "" : ele.pd_pdetail_long,
                            pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid == 0 ? "" : ele.pd_pdetail_unitweightid,
                            pd_pdetail_wide: ele.pd_pdetail_wide == 0 ? "" : ele.pd_pdetail_wide,
                            pd_pdetail_weight: ele.pd_pdetail_weight == 0 ? "" : ele.pd_pdetail_weight,
                            type: "update"
                        }));
                    });
                }
                setProductRow(detail);
                dispatch(getCategory(getProductDetailReducer.data.data[0].pd_product_producttypeid));
                dispatch(getSubCategory(getProductDetailReducer.data.data[0].pd_product_producttypeid, getProductDetailReducer.data.data[0].pd_product_categoryid));
                var offline = [];
                getProductDetailReducer.data.data[0].PdPchanneloffline.map(function(ele) {
                    return offline.push(_object_spread_props(_object_spread({}, ele), {
                        type: "update"
                    }));
                });
                setValOffline(offline);
                var online = [];
                getProductDetailReducer.data.data[0].PdPchannelonline.map(function(ele) {
                    return online.push(_object_spread_props(_object_spread({}, ele), {
                        type: "update"
                    }));
                });
                setValComment(getProductDetailReducer.data.data[0].PdPcomment);
                setValOnline(online);
                setImgPath(getProductDetailReducer.data.data[0].pd_product_image);
                // setDocPath(
                //   getProductDetailReducer.data.data[0].pd_product_evidencefile
                // );
                setPdDate(new Date(getProductDetailReducer.data.data[0].pd_product_pddate));
                var pImg = [];
                getProductDetailReducer.data.data[0].PdPimage.map(function(ele) {
                    return pImg.push({
                        id: nanoid(),
                        pd_pimage_id: ele.pd_pimage_id,
                        pd_pimage_name: ele.pd_pimage_name,
                        type: "update"
                    });
                });
                setGalleryPath(pImg);
                var pFile = [];
                getProductDetailReducer.data.data[0].PdPfile.map(function(ele) {
                    return pFile.push({
                        id: nanoid(),
                        pd_pfile_id: ele.pd_pfile_id,
                        pd_pfile_name: ele.pd_pfile_name,
                        pd_pfile_typeid: ele.pd_pfile_typeid,
                        type: "update"
                    });
                });
                setDocuments(pFile);
            }
        }
    }, [
        getProductDetailReducer
    ]);
    useEffect(function() {
        setIsLoading(createCommentReducer.isFetching);
        if (createCommentReducer.data && !createCommentReducer.isError) {
            setTextsuccess("เพิ่มคอมเมนสำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateComment());
            if (dataID) {
                dispatch(getProductDetail(parseInt(dataID), {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        }
    }, [
        createCommentReducer
    ]);
    useEffect(function() {
        setIsLoading(getAllChannelOfflineReducer.isFetching || getAllChannelOnlineReducer.isFetching || getAllMstUnitReducer.isFetching || getProductTypeReducer.isFetching || getCategoryReducer.isFetching || getSubCategoryReducer.isFetching || getAllMstUnitWeightReducer.isFetching || getAllDimensionReducer.isFetching || getAllProductFileTypeReducer.isFetching);
        if (getAllChannelOfflineReducer.data) {
            var dataOffline = [];
            getAllChannelOfflineReducer.data.data.map(function(ele) {
                return dataOffline.push({
                    label: ele.set_channeloffline_name,
                    value: ele.set_channeloffline_id
                });
            });
            setOptionsOffline(dataOffline);
        }
        if (getAllChannelOnlineReducer.data) {
            var dataOnline = [];
            getAllChannelOnlineReducer.data.data.map(function(ele) {
                return dataOnline.push({
                    label: ele.set_channelonline_name,
                    value: ele.set_channelonline_id
                });
            });
            setOptionsOnline(dataOnline);
        }
        if (getAllMstUnitReducer.data) {
            var dataUnit = [];
            getAllMstUnitReducer.data.data.map(function(ele) {
                return dataUnit.push({
                    label: ele.set_unit_name,
                    value: ele.set_unit_id
                });
            });
            setOptionsUnit(dataUnit);
        }
        if (getEvidenceTypeReducer.data) {
            var dataEvidence = [];
            getEvidenceTypeReducer.data.data.map(function(ele) {
                return dataEvidence.push({
                    label: ele.set_evidencetype_name,
                    value: ele.set_evidencetype_id
                });
            });
            setEvidenceType(dataEvidence);
        }
        if (getProductTypeReducer.data) {
            var dataProduct = [];
            getProductTypeReducer.data.data.map(function(ele) {
                return dataProduct.push({
                    label: ele.set_producttype_name,
                    value: ele.set_producttype_id
                });
            });
            setOptionsType(dataProduct);
        }
        if (getCategoryReducer.data) {
            var dataCate = [];
            getCategoryReducer.data.data.map(function(ele) {
                return dataCate.push({
                    label: ele.set_productcategory_name,
                    value: ele.set_productcategory_id
                });
            });
            setOptionsCate(dataCate);
        }
        if (getSubCategoryReducer.data) {
            var dataSubCate = [];
            getSubCategoryReducer.data.data.map(function(ele) {
                return dataSubCate.push({
                    label: ele.set_productcategorysub_name,
                    value: ele.set_productcategorysub_id
                });
            });
            setOptionsSupCate(dataSubCate);
        }
        if (getAllMstUnitWeightReducer.data) {
            var dataUnitWeight = [];
            getAllMstUnitWeightReducer.data.data.map(function(ele) {
                return dataUnitWeight.push({
                    label: ele.set_unitweight_name,
                    value: ele.set_unitweight_id
                });
            });
            setOptionsUnitWeight(dataUnitWeight);
        }
        if (getAllDimensionReducer.data) {
            var dataDimension = [];
            getAllDimensionReducer.data.data.map(function(ele) {
                return dataDimension.push({
                    label: ele.set_dimension_name,
                    value: ele.set_dimension_id
                });
            });
            setOptionsDimension(dataDimension);
        }
        if (getAllProductFileTypeReducer.data) {
            var dataProductFile = [];
            getAllProductFileTypeReducer.data.data.map(function(ele) {
                return dataProductFile.push({
                    label: ele.set_productfiletype_name,
                    value: ele.set_productfiletype_id
                });
            });
            setOptionsProductFile(dataProductFile);
        }
    }, [
        getAllChannelOfflineReducer,
        getAllChannelOnlineReducer,
        getAllMstUnitReducer,
        getEvidenceTypeReducer,
        getProductTypeReducer,
        getCategoryReducer,
        getSubCategoryReducer,
        getAllMstUnitWeightReducer,
        getAllDimensionReducer,
        getAllProductFileTypeReducer
    ]);
    var _useState18 = _sliced_to_array(useState([
        {
            id: nanoid(),
            pd_pdetail_barcode: "",
            pd_pdetail_unitid: "",
            pd_pdetail_ratio: null,
            pd_pdetail_continer: null,
            pd_pdetail_price: null,
            pd_pdetail_recommentprice: null,
            pd_pdetail_gp: null,
            pd_pdetail_weight: null,
            pd_pdetail_unitweightid: "",
            pd_pdetail_wide: null,
            pd_pdetail_long: null,
            pd_pdetail_high: null,
            pd_pdetail_dimensionid: ""
        }
    ]), 2), productRow = _useState18[0], setProductRow = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), productRowDel = _useState19[0], setProductRowDel = _useState19[1];
    var _useState20 = _sliced_to_array(useState({
        pd_product_businessid: businessID,
        pd_product_nameth: "",
        pd_product_nameen: "",
        pd_product_channelother: "",
        pd_product_producttypeid: "",
        pd_product_categoryid: "",
        pd_product_categorysubid: "",
        pd_product_brand: "",
        pd_product_detail: "",
        pd_product_vat: 7,
        pd_product_evidencenumber: ""
    }), 2), formData = _useState20[0], setFormData = _useState20[1];
    var addProductRow = function() {
        var _ref = _async_to_generator(function(num) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadRow(false);
                        productRow.push({
                            id: nanoid(),
                            pd_pdetail_barcode: "",
                            pd_pdetail_unitid: "",
                            pd_pdetail_ratio: null,
                            pd_pdetail_continer: null,
                            pd_pdetail_price: null,
                            pd_pdetail_recommentprice: null,
                            pd_pdetail_gp: null,
                            pd_pdetail_weight: null,
                            pd_pdetail_unitweightid: "",
                            pd_pdetail_wide: null,
                            pd_pdetail_long: null,
                            pd_pdetail_high: null,
                            pd_pdetail_dimensionid: "",
                            type: "create"
                        });
                        return [
                            4,
                            setProductRow(productRow)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setLoadRow(true)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function addProductRow(num) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeOption = function(action, event, item) {
        if (action == "offline") {
            var offline = [];
            event.map(function(ele) {
                if (dataID) {
                    var find = item.find(function(v) {
                        return v.pd_pchanneloffline_channelofflineid == ele.value;
                    });
                    offline.push({
                        pd_pchanneloffline_channelofflineid: ele.value,
                        pd_pchanneloffline_name: ele.label,
                        pd_pchanneloffline_businessid: businessID,
                        pd_pchanneloffline_id: find ? find.pd_pchanneloffline_id : "",
                        pd_pchanneloffline_productid: parseInt(dataID),
                        type: find ? "update" : "create"
                    });
                } else {
                    offline.push({
                        pd_pchanneloffline_channelofflineid: ele.value,
                        pd_pchanneloffline_name: ele.label
                    });
                }
            });
            setValOffline(offline);
        }
        if (action == "online") {
            var online = [];
            event.map(function(ele) {
                if (dataID) {
                    var find = item.find(function(v) {
                        return v.pd_pchannelonline_channelonlineid == ele.value;
                    });
                    online.push({
                        pd_pchannelonline_channelonlineid: ele.value,
                        pd_pchannelonline_name: ele.label,
                        pd_pchannelonline_businessid: businessID,
                        pd_pchannelonline_id: find ? find.pd_pchannelonline_id : "",
                        pd_pchannelonline_productid: parseInt(dataID),
                        type: find ? "update" : "create"
                    });
                } else {
                    online.push({
                        pd_pchannelonline_channelonlineid: ele.value,
                        pd_pchannelonline_name: ele.label
                    });
                }
            });
            setValOnline(online);
        }
    };
    var onDeleteProduct = function(removeId, item) {
        setProductRow(function(doc) {
            return doc.filter(function(row) {
                return row.id !== removeId;
            });
        });
        if (item.type === "update") {
            var aa = {
                pd_pdetail_id: item.pd_pdetail_id
            };
            setProductRowDel(function(prev) {
                return _to_consumable_array(prev).concat([
                    aa
                ]);
            });
        }
    };
    var _useState21 = _sliced_to_array(useState(""), 2), comment = _useState21[0], setComment = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), imgPath = _useState22[0], setImgPath = _useState22[1];
    var _useState23 = _sliced_to_array(useState(""), 2), docPath = _useState23[0], setDocPath = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), galleryPath = _useState24[0], setGalleryPath = _useState24[1];
    var _useState25 = _sliced_to_array(useState([]), 2), galleryDel = _useState25[0], setGalleryDel = _useState25[1];
    var _useState26 = _sliced_to_array(useState(""), 2), pdDate = _useState26[0], setPdDate = _useState26[1];
    var onComment = function(e) {
        e.preventDefault();
        console.log(comment);
        var data = {
            pd_pcomment_businessid: parseInt(businessID),
            pd_pcomment_productid: parseInt(dataID),
            pd_pcomment_detail: comment,
            pd_pcomment_by: 3,
            pd_pcomment_memid: parseInt(memID)
        };
        dispatch(createComment(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState27 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState27[0], setModalSuccess = _useState27[1];
    var _useState28 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState28[0], setModalAlert = _useState28[1];
    var _useState29 = _sliced_to_array(useState([
        {
            id: nanoid(),
            pd_pfile_typeid: null,
            pd_pfile_name: null,
            type: "create"
        }
    ]), 2), documents = _useState29[0], setDocuments = _useState29[1];
    var _useState30 = _sliced_to_array(useState([]), 2), documentsDel = _useState30[0], setDocumentsDel = _useState30[1];
    var addDocument = function(num) {
        // <-- not Button -->
        // for (var i = 0; i < num; i++) {
        setDocuments(function(row) {
            return _to_consumable_array(row).concat([
                {
                    id: nanoid(),
                    pd_pfile_typeid: null,
                    pd_pfile_name: null,
                    type: "create"
                }
            ]);
        });
    };
    var deleteDocument = function(removeId, item) {
        setDocuments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                pd_pfile_id: item.pd_pfile_id
            };
            setDocumentsDel(_to_consumable_array(documentsDel).concat([
                del
            ]));
        }
    };
    var disable = param.view == "view" ? true : false;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-1",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/product",
                                className: "tc-7  text-decoration-none",
                                children: "สินค้าของฉัน"
                            })
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: dataID ? "แก้ไขสินค้าของฉัน" : "สร้างสินค้าของฉัน"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formData,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    if (!values.pd_product_nameth || !values.pd_product_nameen == null || !productRow[0].pd_pdetail_barcode || !productRow[0].pd_pdetail_unitid || !hasInputValue(productRow[0].pd_pdetail_recommentprice) || !hasInputValue(productRow[0].pd_pdetail_price) || !pdDate || !imgPath) {
                        setModalAlert(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                        return false;
                    } else if (dataID) {
                        var _loop = function(key) {
                            if (Object.hasOwnProperty.call(values, key) && key !== "pd_product_status") {
                                var value = values[key];
                                if (Array.isArray(value)) {
                                    value.forEach(function(item) {
                                        return formdataPayload.append(key, item);
                                    });
                                } else if (value !== undefined) {
                                    formdataPayload.append(key, value);
                                // } else if (key == "pd_product_status" && value) {
                                //   // if (formData.pd_product_status == 5) {
                                //     formdataPayload.append(key, 1);
                                // }
                                // } else if (values === "pd_product_status") {
                                //   if (formData.pd_product_status == 5) {
                                //     formdataPayload.append('pd_product_status', 1);
                                //   }
                                }
                            }
                        };
                        var createProductRow = [];
                        productRow.filter(function(v) {
                            return v.type == "create" && v.pd_pdetail_barcode != "";
                        }).map(function(ele) {
                            return createProductRow.push({
                                pd_pdetail_barcode: ele.pd_pdetail_barcode,
                                pd_pdetail_ratio: toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_continer: "1x" + toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_price: toNumberOrZero(ele.pd_pdetail_price),
                                pd_pdetail_recommentprice: toNumberOrZero(ele.pd_pdetail_recommentprice),
                                pd_pdetail_gp: calculateDetailGp(ele.pd_pdetail_price, ele.pd_pdetail_recommentprice),
                                pd_pdetail_weight: ele.pd_pdetail_weight ? parseFloat(ele.pd_pdetail_weight) : 0,
                                pd_pdetail_unitid: ele.pd_pdetail_unitid ? ele.pd_pdetail_unitid : 0,
                                pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid ? ele.pd_pdetail_unitweightid : 0,
                                pd_pdetail_wide: ele.pd_pdetail_wide ? parseFloat(ele.pd_pdetail_wide) : 0,
                                pd_pdetail_high: ele.pd_pdetail_high ? parseFloat(ele.pd_pdetail_high) : 0,
                                pd_pdetail_long: ele.pd_pdetail_long ? parseFloat(ele.pd_pdetail_long) : 0,
                                pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid ? ele.pd_pdetail_dimensionid : 0
                            });
                        });
                        var updateProductRow = [];
                        productRow.filter(function(v) {
                            return v.type == "update" && v.pd_pdetail_barcode != "";
                        }).map(function(ele) {
                            return updateProductRow.push({
                                pd_pdetail_id: ele.pd_pdetail_id,
                                pd_pdetail_barcode: ele.pd_pdetail_barcode,
                                pd_pdetail_ratio: toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_continer: "1x" + toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_price: toNumberOrZero(ele.pd_pdetail_price),
                                pd_pdetail_recommentprice: toNumberOrZero(ele.pd_pdetail_recommentprice),
                                pd_pdetail_gp: calculateDetailGp(ele.pd_pdetail_price, ele.pd_pdetail_recommentprice),
                                pd_pdetail_weight: ele.pd_pdetail_weight ? parseFloat(ele.pd_pdetail_weight) : 0,
                                pd_pdetail_unitid: ele.pd_pdetail_unitid ? ele.pd_pdetail_unitid : 0,
                                pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid ? ele.pd_pdetail_unitweightid : 0,
                                pd_pdetail_wide: ele.pd_pdetail_wide ? parseFloat(ele.pd_pdetail_wide) : 0,
                                pd_pdetail_high: ele.pd_pdetail_high ? parseFloat(ele.pd_pdetail_high) : 0,
                                pd_pdetail_long: ele.pd_pdetail_long ? parseFloat(ele.pd_pdetail_long) : 0,
                                pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid ? ele.pd_pdetail_dimensionid : 0
                            });
                        });
                        var updateOffline = [];
                        valOffline// .filter((v) => v.type == "update")
                        .map(function(ele) {
                            return updateOffline.push({
                                pd_pchanneloffline_channelofflineid: ele.pd_pchanneloffline_channelofflineid,
                                pd_pchanneloffline_name: ele.pd_pchanneloffline_name
                            });
                        });
                        var updateOnline = [];
                        valOnline// .filter((v) => v.type == "update")
                        .map(function(ele) {
                            return updateOnline.push({
                                pd_pchannelonline_channelonlineid: ele.pd_pchannelonline_channelonlineid,
                                pd_pchannelonline_name: ele.pd_pchannelonline_name
                            });
                        });
                        var galleryCreate = [];
                        galleryPath.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return galleryCreate.push({
                                pd_pimage_name: ele.pd_pimage_name
                            });
                        });
                        var galleryUpdate = [];
                        galleryPath.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return galleryUpdate.push({
                                pd_pimage_name: ele.pd_pimage_name,
                                pd_pimage_id: ele.pd_pimage_id
                            });
                        });
                        for(var key in values)_loop(key);
                        formdataPayload.append("pddetailcreate", JSON.stringify(createProductRow));
                        formdataPayload.append("pddetailupdate", JSON.stringify(updateProductRow));
                        formdataPayload.append("pddetaildelete", JSON.stringify(productRowDel));
                        formdataPayload.append("offlineupdate", JSON.stringify(updateOffline));
                        formdataPayload.append("onlineupdate", JSON.stringify(updateOnline));
                        formdataPayload.append("pd_product_image", imgPath);
                        // formdataPayload.append("pd_product_evidencefile", docPath);
                        formdataPayload.append("imagecreate", JSON.stringify(galleryCreate));
                        formdataPayload.append("imageupdate", JSON.stringify(galleryUpdate));
                        formdataPayload.append("imagedelete", JSON.stringify(galleryDel));
                        formdataPayload.append("pd_product_pddate", pdDate ? moment(pdDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "");
                        formdataPayload.append("pd_product_price", JSON.stringify(toNumberOrZero(productRow[0].pd_pdetail_price)));
                        formdataPayload.append("pd_product_recommentprice", JSON.stringify(toNumberOrZero(productRow[0].pd_pdetail_recommentprice)));
                        formdataPayload.append("pd_product_gp", JSON.stringify(calculateProductGp(productRow[0].pd_pdetail_price, productRow[0].pd_pdetail_recommentprice)));
                        if (formData.pd_product_status == 5) {
                            formdataPayload.append("pd_product_status", 2);
                        }
                        var docCreate = [];
                        documents.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return docCreate.push({
                                pd_pfile_businessid: businessID,
                                pd_pfile_name: ele.pd_pfile_name,
                                pd_pfile_typeid: ele.pd_pfile_typeid
                            });
                        });
                        formdataPayload.append("filecreate", JSON.stringify(docCreate));
                        var docUpdate = [];
                        documents.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return docUpdate.push({
                                pd_pfile_businessid: businessID,
                                pd_pfile_id: ele.pd_pfile_id,
                                pd_pfile_name: ele.pd_pfile_name,
                                pd_pfile_typeid: ele.pd_pfile_typeid
                            });
                        });
                        formdataPayload.append("fileupdate", JSON.stringify(docUpdate));
                        formdataPayload.append("filedelete", JSON.stringify(documentsDel));
                        dispatch(updateProduct(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        var _loop1 = function(key1) {
                            if (Object.hasOwnProperty.call(values, key1)) {
                                var value = values[key1];
                                if (key1 === "img_file" && typeof value === "string" && value) {
                                    var blob = base64ToBlob(value);
                                    formdataPayload.append(key1, blob, "img_file.jpg");
                                } else if (Array.isArray(value)) {
                                    value.forEach(function(item) {
                                        return formdataPayload.append(key1, item);
                                    });
                                } else if (value !== undefined) {
                                    formdataPayload.append(key1, value);
                                }
                            }
                        };
                        var dataProduct = [];
                        productRow.filter(function(v) {
                            return v.pd_pdetail_barcode != "";
                        }).map(function(ele) {
                            return dataProduct.push({
                                pd_pdetail_barcode: ele.pd_pdetail_barcode,
                                pd_pdetail_continer: "1x" + toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_dimensionid: ele.pd_pdetail_dimensionid ? ele.pd_pdetail_dimensionid : 0,
                                pd_pdetail_gp: calculateDetailGp(ele.pd_pdetail_price, ele.pd_pdetail_recommentprice),
                                pd_pdetail_high: ele.pd_pdetail_high ? parseFloat(ele.pd_pdetail_high) : 0,
                                pd_pdetail_long: ele.pd_pdetail_long ? parseFloat(ele.pd_pdetail_long) : 0,
                                pd_pdetail_price: toNumberOrZero(ele.pd_pdetail_price),
                                pd_pdetail_ratio: toIntOrZero(ele.pd_pdetail_ratio),
                                pd_pdetail_recommentprice: toNumberOrZero(ele.pd_pdetail_recommentprice),
                                pd_pdetail_unitid: ele.pd_pdetail_unitid ? ele.pd_pdetail_unitid : 0,
                                pd_pdetail_unitweightid: ele.pd_pdetail_unitweightid ? ele.pd_pdetail_unitweightid : 0,
                                pd_pdetail_weight: ele.pd_pdetail_weight ? parseFloat(ele.pd_pdetail_weight) : 0,
                                pd_pdetail_wide: ele.pd_pdetail_wide ? parseFloat(ele.pd_pdetail_wide) : 0
                            });
                        });
                        for(var key1 in values)_loop1(key1);
                        formdataPayload.append("pd_product_price", JSON.stringify(toNumberOrZero(productRow[0].pd_pdetail_price)));
                        formdataPayload.append("pd_product_recommentprice", JSON.stringify(toNumberOrZero(productRow[0].pd_pdetail_recommentprice)));
                        formdataPayload.append("pd_product_gp", JSON.stringify(calculateProductGp(productRow[0].pd_pdetail_price, productRow[0].pd_pdetail_recommentprice)));
                        formdataPayload.append("pd_product_unitid", JSON.stringify(parseInt(productRow[0].pd_pdetail_unitid)));
                        formdataPayload.append("pd_product_weight", productRow[0].pd_pdetail_weight ? JSON.stringify(parseFloat(productRow[0].pd_pdetail_weight)) : 0);
                        formdataPayload.append("pd_product_unitweightid", productRow[0].pd_pdetail_unitweightid ? JSON.stringify(parseInt(productRow[0].pd_pdetail_unitweightid)) : parseInt(0));
                        formdataPayload.append("pd_product_wide", productRow[0].pd_pdetail_wide ? JSON.stringify(parseFloat(productRow[0].pd_pdetail_wide)) : 0);
                        formdataPayload.append("pd_product_long", productRow[0].pd_pdetail_long ? JSON.stringify(parseFloat(productRow[0].pd_pdetail_long)) : 0);
                        formdataPayload.append("pd_product_high", productRow[0].pd_pdetail_high ? JSON.stringify(parseFloat(productRow[0].pd_pdetail_high)) : 0);
                        formdataPayload.append("pd_product_dimensionid", productRow[0].pd_pdetail_dimensionid ? JSON.stringify(parseInt(productRow[0].pd_pdetail_dimensionid)) : parseInt(0));
                        formdataPayload.append("pd_product_barcode", productRow[0].pd_pdetail_barcode);
                        formdataPayload.append("offlinecreate", JSON.stringify(valOffline));
                        formdataPayload.append("onlinecreate", JSON.stringify(valOnline));
                        formdataPayload.append("pddetailcreate", JSON.stringify(dataProduct));
                        formdataPayload.append("pd_product_image", imgPath ? imgPath : "");
                        // formdataPayload.append(
                        //   "pd_product_evidencefile",
                        //   docPath ? docPath : ""
                        // );
                        formdataPayload.append("pd_product_pddate", pdDate ? moment(pdDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "");
                        var gallery = [];
                        galleryPath.map(function(ele) {
                            return gallery.push({
                                pd_pimage_name: ele.pd_pimage_name
                            });
                        });
                        formdataPayload.append("imagecreate", JSON.stringify(gallery));
                        var docCreate1 = [];
                        documents.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return docCreate1.push({
                                pd_pfile_businessid: businessID,
                                pd_pfile_name: ele.pd_pfile_name,
                                pd_pfile_typeid: ele.pd_pfile_typeid
                            });
                        });
                        formdataPayload.append("filecreate", JSON.stringify(docCreate1));
                        console.log("formdataPayload :", formdataPayload);
                        dispatch(createNewProduct(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param1) {
                    var handleSubmit = param1.handleSubmit, handleChange = param1.handleChange, touched = param1.touched, errors = param1.errors, values = param1.values, setFieldValue = param1.setFieldValue, isInvalid = param1.isInvalid, isValid = param1.isValid;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Form, {
                                noValidate: true,
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    handleSubmit();
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("fieldset", {
                                        disabled: formdisabled,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลทั่วไป"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "รหัสสินค้า",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: "*"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_code",
                                                                                    className: "form-control",
                                                                                    placeholder: "รหัสสินค้า",
                                                                                    value: values.pd_product_code,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_code: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: true
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "Barcode",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_barcode",
                                                                                    className: "form-control",
                                                                                    placeholder: "barcode",
                                                                                    value: productRow[0].pd_pdetail_barcode,
                                                                                    disabled: true,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_barcode: e.target.value
                                                                                        })); // Update formData state
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ชื่อสินค้าภาษาไทย ( TH )",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_nameth",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อสินค้าภาษาไทย ( TH )",
                                                                                    value: values.pd_product_nameth,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_nameth: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    isInvalid: !!errors.pd_product_nameth,
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "ชื่อสินค้าภาษาอังกฤษ",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_nameen",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกชื่อสินค้าภาษาอังกฤษ",
                                                                                    value: values.pd_product_nameen,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_nameen: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    isInvalid: !!errors.pd_product_nameen,
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ช่องทางจำหน่ายออฟไลน์"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    className: "w-100 select-st-1 select-multi",
                                                                                    name: "pchanneloffline_id",
                                                                                    as: "select",
                                                                                    isMulti: true,
                                                                                    options: optionsOffline,
                                                                                    onChange: function(e) {
                                                                                        handleChangeOption("offline", e, valOffline);
                                                                                    },
                                                                                    placeholder: "เลือกช่องทางจำหน่ายออฟไลน์",
                                                                                    value: optionsOffline.filter(function(opt) {
                                                                                        return valOffline.some(function(v) {
                                                                                            return v.pd_pchanneloffline_channelofflineid === opt.value;
                                                                                        });
                                                                                    }),
                                                                                    isDisabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ช่องทางจำหน่ายออนไลน์"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                    className: "w-100 select-st-1 select-multi",
                                                                                    name: "pchannelonline_id",
                                                                                    as: "select",
                                                                                    isMulti: true,
                                                                                    options: optionsOnline,
                                                                                    onChange: function(e) {
                                                                                        handleChangeOption("online", e, valOnline);
                                                                                    },
                                                                                    placeholder: "เลือกช่องทางจำหน่ายออนไลน์",
                                                                                    value: optionsOnline.filter(function(opt) {
                                                                                        return valOnline.some(function(v) {
                                                                                            return v.pd_pchannelonline_channelonlineid === opt.value;
                                                                                        });
                                                                                    }),
                                                                                    // isClearable={(e) => aaaaaaa(e)}
                                                                                    // {value.some((v) => !v.isFixed)}
                                                                                    isDisabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-3 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ช่องทางจำหน่ายอื่นๆ"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_channelother",
                                                                                    className: "form-control",
                                                                                    placeholder: "กรอกช่องทางจำหน่ายอื่นๆ",
                                                                                    value: values.pd_product_channelother,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_channelother: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: [
                                                                                        "วันหมดอายุ",
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "text-danger ms-1",
                                                                                            children: " *"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "pr-[15px]",
                                                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                        inputFormat: "DD/MM/YYYY",
                                                                                        dateFormat: "dd/MM/yyyy",
                                                                                        // minDate={moment()}\
                                                                                        // minDate={new Date()}
                                                                                        placeholderText: "วันหมดอายุ",
                                                                                        selected: pdDate,
                                                                                        onChange: function(date) {
                                                                                            setPdDate(date);
                                                                                        // setFieldValue(
                                                                                        //   "pd_product_pddate",
                                                                                        //   moment(date).format("YYYY-MM-DD")
                                                                                        // );
                                                                                        },
                                                                                        placeholder: "DD/MM/YYYY",
                                                                                        className: "w-100 datepicker2",
                                                                                        value: pdDate,
                                                                                        disabled: disable
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "อายุสินค้า ( วัน )"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_dayexpire",
                                                                                    disabled: true,
                                                                                    className: "form-control",
                                                                                    placeholder: "อายุสินค้า ( วัน )",
                                                                                    // value={dayjs(pdDate, new Date())}
                                                                                    value: pdDate ? dayjs(moment(pdDate).format("YYYY-MM-DD")).diff(dayjs(moment(new Date()).format("YYYY-MM-DD")), "day") > 0 ? dayjs(moment(pdDate).format("YYYY-MM-DD")).diff(dayjs(moment(new Date()).format("YYYY-MM-DD")), "day") : "หมดอายุ" : ""
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ประเภทสินค้า"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_producttypeid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกประเภทสินค้า",
                                                                                        options: optionsType,
                                                                                        value: optionsType.filter(function(item) {
                                                                                            return item.value === values.pd_product_producttypeid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_producttypeid: e.value,
                                                                                                pd_product_categoryid: "",
                                                                                                pd_product_categorysubid: ""
                                                                                            })); // Update formData state
                                                                                            dispatch(getCategory(e.value));
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หมวดหมู่หลัก"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_categoryid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกหมวดหมู่หลัก",
                                                                                        options: optionsCate,
                                                                                        value: optionsCate.filter(function(item) {
                                                                                            return item.value === values.pd_product_categoryid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_categoryid: e.value,
                                                                                                pd_product_categorysubid: ""
                                                                                            })); // Update formData state
                                                                                            dispatch(getSubCategory(formData.pd_product_producttypeid, e.value));
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หมวดหมู่ย่อย"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_categorysubid",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกหมวดหมู่ย่อย",
                                                                                        options: optionsSupCate,
                                                                                        value: optionsSupCate.filter(function(item) {
                                                                                            return item.value === values.pd_product_categorysubid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_categorysubid: e.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "ยี่ห้อ (แบรนด์)"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    type: "text",
                                                                                    name: "pd_product_brand",
                                                                                    placeholder: "ยี่ห้อ (แบรนด์)",
                                                                                    value: values.pd_product_brand,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_brand: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                                                    className: "mb-1",
                                                                                    children: "รายละเอียดสินค้า"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                    as: "textarea",
                                                                                    rows: 3,
                                                                                    name: "pd_product_detail",
                                                                                    value: values.pd_product_detail,
                                                                                    onChange: function(e) {
                                                                                        handleChange(e); // Update Formik's state
                                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                            pd_product_detail: e.target.value
                                                                                        })); // Update formData state
                                                                                    },
                                                                                    disabled: disable
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "กำหนดราคานำเสนอ"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "pt-3 px-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-3 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "form-st-3 sm pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "อัตราภาษีขาย",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_product_vat",
                                                                                        className: "w-100 select-st-1",
                                                                                        placeholder: "เลือกอัตราภาษีขาย",
                                                                                        options: optionsVAt,
                                                                                        value: optionsVAt.filter(function(item) {
                                                                                            return item.value === values.pd_product_vat;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                                pd_product_vat: e.value
                                                                                            })); // Update formData state
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                productRow.map(function(item, i) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-2",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-2 col-md-2",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "Barcode",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_barcode",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอก Barcode",
                                                                                            value: item.pd_pdetail_barcode,
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_barcode: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            disabled: disable
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "form-st-3 sm pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "หน่วย",
                                                                                                    i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: "*"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "pd_pdetail_unitid",
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsUnit,
                                                                                                placeholder: "เลือกหน่วย",
                                                                                                value: optionsUnit.filter(function(d) {
                                                                                                    return d.value == item.pd_pdetail_unitid;
                                                                                                }),
                                                                                                onChange: function(e) {
                                                                                                    setProductRow(function(prev) {
                                                                                                        return prev.map(function(el) {
                                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                                pd_pdetail_unitid: e.value
                                                                                                            }) : el;
                                                                                                        });
                                                                                                    });
                                                                                                },
                                                                                                isDisabled: disable
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "อัตราส่วน(ชิ้น)",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_ratio",
                                                                                            className: "form-control",
                                                                                            placeholder: "อัตราส่วน",
                                                                                            value: item.pd_pdetail_ratio,
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_ratio: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            disabled: disable
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "Container"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_continer",
                                                                                            className: "form-control",
                                                                                            placeholder: "Container",
                                                                                            value: item.pd_pdetail_ratio ? "1x" + item.pd_pdetail_ratio : "1x",
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_ratio: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "ราคานำเสนอ",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_price",
                                                                                            className: "form-control",
                                                                                            placeholder: "ราคานำเสนอ",
                                                                                            value: item.pd_pdetail_price,
                                                                                            style: {
                                                                                                background: "#E4F5FF"
                                                                                            },
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_price: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            disabled: disable
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl col-md",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "ราคาแนะนำขาย",
                                                                                                i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "text-danger ms-1",
                                                                                                    children: "*"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_recommentprice",
                                                                                            className: "form-control",
                                                                                            placeholder: "ราคาแนะนำขาย",
                                                                                            value: item.pd_pdetail_recommentprice,
                                                                                            style: {
                                                                                                background: "#2DC76D24"
                                                                                            },
                                                                                            onChange: function(e) {
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                            pd_pdetail_recommentprice: e.target.value
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            disabled: disable
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-1 col-md-3",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "GP"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "pd_pdetail_gp",
                                                                                            className: "form-control",
                                                                                            placeholder: "GP",
                                                                                            value: hasInputValue(item.pd_pdetail_price) && hasInputValue(item.pd_pdetail_recommentprice) ? calculateDetailGp(item.pd_pdetail_price, item.pd_pdetail_recommentprice).toFixed(2) : 0,
                                                                                            disabled: true
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-1 col-md-1",
                                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                    className: "mb-2 mt-4 ml-3 form-st-3 pb-1",
                                                                                    children: i != 0 && /*#__PURE__*/ _jsx("button", {
                                                                                        type: "button",
                                                                                        className: "btn btn-delete-file ",
                                                                                        disabled: disable,
                                                                                        onClick: function(e) {
                                                                                            return onDeleteProduct(item.id, item);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, i);
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-6 col-md-12",
                                                                        children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                            className: "mb-2 form-st-3 pb-1",
                                                                            children: /*#__PURE__*/ _jsx(Button, {
                                                                                type: "button",
                                                                                className: "btn-st-3 me-3",
                                                                                onClick: function() {
                                                                                    return addProductRow(1);
                                                                                },
                                                                                disabled: disable,
                                                                                children: "เพิ่มราคาและอัตราส่วน"
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "ข้อมูลเฉพาะสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: productRow.map(function(item, i) {
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-10",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "Barcode",
                                                                                            i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_barcode",
                                                                                        className: "form-control",
                                                                                        placeholder: "กรอก Barcode",
                                                                                        value: item.pd_pdetail_barcode,
                                                                                        disabled: true,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_barcode: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-2",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "หน่วย",
                                                                                            i == 0 && /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_pdetail_unitid",
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsUnit,
                                                                                        placeholder: "เลือกหน่วย",
                                                                                        value: optionsUnit.filter(function(d) {
                                                                                            return d.value == item.pd_pdetail_unitid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_unitid: e.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        isDisabled: true
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-10",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "น้ำหนักสินค้า"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_weight",
                                                                                        className: "form-control",
                                                                                        placeholder: "น้ำหนักสินค้า",
                                                                                        value: item.pd_pdetail_weight,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_weight: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        disabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-2",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หน่วยน้ำหนัก"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_pdetail_unitweightid",
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsUnitWeight,
                                                                                        placeholder: "เลือกหน่วยน้ำหนัก",
                                                                                        value: optionsUnitWeight.filter(function(d) {
                                                                                            return d.value == item.pd_pdetail_unitweightid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_unitweightid: e.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความกว้าง"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_wide",
                                                                                        className: "form-control",
                                                                                        placeholder: "ความกว้าง",
                                                                                        value: item.pd_pdetail_wide,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_wide: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        disabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความยาว"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_long",
                                                                                        className: "form-control",
                                                                                        placeholder: "ความยาว",
                                                                                        value: item.pd_pdetail_long,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_long: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        disabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความสูง"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "pd_pdetail_high",
                                                                                        className: "form-control",
                                                                                        placeholder: "ความสูง",
                                                                                        value: item.pd_pdetail_high,
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_high: e.target.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        disabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "หน่วย Dimension"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "pd_pdetail_dimensionid",
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsDimension,
                                                                                        placeholder: "Dimension",
                                                                                        value: optionsDimension.filter(function(d) {
                                                                                            return d.value == item.pd_pdetail_dimensionid;
                                                                                        }),
                                                                                        onChange: function(e) {
                                                                                            setProductRow(function(prev) {
                                                                                                return prev.map(function(el) {
                                                                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                        pd_pdetail_dimensionid: e.value
                                                                                                    }) : el;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        isDisabled: disable
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("hr", {
                                                                            className: "my-2",
                                                                            style: {
                                                                                opacity: 0.1
                                                                            }
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "เอกสารมาตราฐานการผลิต"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "row gx-xl-4",
                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-6 col-md-12",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "เลขที่ใบอนุญาต"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "pd_product_evidencenumber",
                                                                                placeholder: "เลขที่ใบอนุญาต",
                                                                                value: values.pd_product_evidencenumber,
                                                                                onChange: function(e) {
                                                                                    handleChange(e); // Update Formik's state
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        pd_product_evidencenumber: e.target.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                // isInvalid={!!errors.pd_product_evidencenumber}
                                                                                disabled: disable
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        documents.map(function(item, index) {
                                                            return /*#__PURE__*/ _jsx(EvidenceDoc, {
                                                                setFieldValue: setFieldValue,
                                                                values: values,
                                                                item: item,
                                                                index: index,
                                                                setDocuments: setDocuments,
                                                                modalObj: modalObj,
                                                                setModalObj: setModalObj,
                                                                evidenceType: evidenceType,
                                                                setIsLoading: setIsLoading,
                                                                optionsProductFile: optionsProductFile,
                                                                disabled: disable,
                                                                ondeleteDocument: function(id) {
                                                                    deleteDocument(id, item);
                                                                }
                                                            }, index);
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "px-3 py-4",
                                                            children: /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn btn-st-4",
                                                                onClick: addDocument,
                                                                disabled: disable,
                                                                children: "เพิ่มเอกสาร"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8  fs-18 fw-bold px-3",
                                                            children: "รูปภาพสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "pt-3 px-3",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-3",
                                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-16 px-3",
                                                                                children: [
                                                                                    "ภาพสินค้ามาตราฐาน",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-danger ms-1",
                                                                                        children: "*"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-3",
                                                                            children: /*#__PURE__*/ _jsx(ImageProductUpload, {
                                                                                isUpdate: dataID != undefined,
                                                                                setFieldValue: setFieldValue,
                                                                                setFormData: setFormData,
                                                                                setImgPath: setImgPath,
                                                                                imgPath: imgPath,
                                                                                setIsLoading: setIsLoading,
                                                                                setModalObj: setModalObj,
                                                                                modalObj: modalObj,
                                                                                values: values,
                                                                                view: param.view
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-8 col-md-6"
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "offset-xl-2 col-xl-4 offset-md-3 col-md-4",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "อัปโหลดรูปภาพพื้นหลังขาวเท่านั้น"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "อัปโหลดรูปภาพขนาดไฟล์ไม่เกิน 2 MB"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "อัปโหลดรูปภาพขนาดภาพไม่เกิน 1000x1000"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "pr-1",
                                                                                            children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                                style: {
                                                                                                    fontSize: 5
                                                                                                }
                                                                                            })
                                                                                        }),
                                                                                        "รูปสินค้าจะแสดงผลหน้าผลการค้นหา และหน้าสินค้าแนะนำ"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4 mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-2 col-md-3",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "fs-16 px-3",
                                                                                children: "แกลลอรี่"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-10 col-md-9",
                                                                            children: /*#__PURE__*/ _jsx(ImageGalleryUpload, {
                                                                                isUpdate: dataID != undefined,
                                                                                setFieldValue: setFieldValue,
                                                                                values: values,
                                                                                view: param.view,
                                                                                galleryPath: galleryPath,
                                                                                setGalleryPath: setGalleryPath,
                                                                                galleryDel: galleryDel,
                                                                                setGalleryDel: setGalleryDel,
                                                                                setIsLoading: setIsLoading,
                                                                                setModalObj: setModalObj,
                                                                                modalObj: modalObj,
                                                                                disabled: disable
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "row gx-xl-4 mt-3",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "offset-xl-2 col-xl-4 offset-md-3 col-md-5",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-12",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "pr-1",
                                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                            style: {
                                                                                                fontSize: 5
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    "อัปโหลดรูปภาพขนาดไฟล์ไม่เกิน 2 MB"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-12",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "pr-1",
                                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                            style: {
                                                                                                fontSize: 5
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    "อัปโหลดรูปภาพขนาดภาพไม่เกิน 1000x1000"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "fs-12",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "pr-1",
                                                                                        children: /*#__PURE__*/ _jsx(CircleIcon, {
                                                                                            style: {
                                                                                                fontSize: 5
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    "รูปสินค้าจะแสดงผลหน้าผลการค้นหา และหน้าสินค้าแนะนำ"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "card card-st-3 mb-3",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-body px-xl-3",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8 fs-18 fw-bold px-4",
                                                            children: "คำแนะนำในการกรอกข้อมูล"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "pt-3 px-3",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "row gx-xl-4",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: productRow[0].pd_pdetail_barcode ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "Barcode หลัก"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: formData.pd_product_nameth && formData.pd_product_nameen ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "ชื่อสินค้าภาษาไทย / ภาษาอังกฤษ"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: hasInputValue(productRow[0].pd_pdetail_price) && hasInputValue(productRow[0].pd_pdetail_recommentprice) ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "ราคานำเสนอหลัก / ราคาแนะนำขายหลัก / อัตราภาษีขาย"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "col-xl-12 col-md-12",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fs-16 px-3 mb-2",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "pr-2",
                                                                                    children: imgPath ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                        style: {
                                                                                            color: "#2DC76D"
                                                                                        }
                                                                                    }) : /*#__PURE__*/ _jsx(ErrorIcon, {
                                                                                        style: {
                                                                                            color: "#FF0000"
                                                                                        }
                                                                                    })
                                                                                }),
                                                                                "เพิ่มรูปสินค้ามาตราฐาน"
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "text-end btn-group-control",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        className: "btn-st-6 me-3 btn",
                                                        href: "/product",
                                                        children: "ยกเลิก"
                                                    }),
                                                    param.view != "view" && /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        onClick: function() {
                                                            handleSubmit();
                                                        },
                                                        className: "btn btn-dg",
                                                        children: formData.pd_product_status == 5 ? "ส่งอนุมัติ" : "บันทึก"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(ModalAllder, {
                                modal: modalAlert,
                                setModal: setModalAlert,
                                htitle: "แจ้งเตือน",
                                hbtn: false,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-center pt-4 tc-5",
                                        style: {
                                            fontSize: "22px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !values.pd_product_nameth && "- กรอกชื่อสินค้าภาษาไทย ( TH )"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !values.pd_product_nameen && "- กรอกชื่อสินค้าภาษาอังกฤษ ( EN )"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !productRow[0].pd_pdetail_barcode && "- กรอก Barcode สินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !productRow[0].pd_pdetail_unitid && "- เลือกหน่วยสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !productRow[0].pd_pdetail_ratio && "- กรอกอัตราส่วนสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !hasInputValue(productRow[0].pd_pdetail_price) && "- กรอกราคานำเสนอสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !hasInputValue(productRow[0].pd_pdetail_recommentprice) && "- กรอกราคาแนะนำขายสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !pdDate && "- เลือกวันหมดอายุ"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: !imgPath && "- ภาพสินค้ามาตราฐาน"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex align-items-center pb-4 pt-5 ",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-3 mx-auto",
                                            onClick: function() {
                                                return setModalAlert(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: false
                                                    });
                                                });
                                            },
                                            children: "ยืนยัน"
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            }),
            valComment.length > 0 && dataID && /*#__PURE__*/ _jsx("div", {
                className: "card card-st-3 mb-3",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body px-10",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "pt-3 px-3",
                        children: [
                            valComment.map(function(ele, i) {
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "row gx-xl-2 mb-4",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-1 col-md-1 text-end",
                                            children: ele.pd_pcomment_by == 1 && /*#__PURE__*/ _jsx(Stack, {
                                                direction: "row",
                                                justifyContent: "flex-end",
                                                spacing: 3,
                                                children: /*#__PURE__*/ _jsx(Image, {
                                                    src: "/images/Avatar.png",
                                                    roundedCircle: true,
                                                    style: {
                                                        width: 50,
                                                        border: "4px solid #107BEF",
                                                        borderRadius: 30
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-10 col-md-10",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "card-st-1 mx-3 p-3",
                                                style: {
                                                    background: "#F6E1E3"
                                                },
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Stack, {
                                                        direction: "row",
                                                        justifyContent: "space-between",
                                                        spacing: 3,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "fw-500",
                                                                children: ele.pd_pcomment_by == 1 && "SYSTEM" || ele.pd_pcomment_by == 2 && "PARTNER" || ele.pd_pcomment_by == 3 && "ADMIN"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "tc-12",
                                                                children: moment(ele.pd_pcomment_issuedate).format("DD/MM/YYYY HH:mm")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: ele.pd_pcomment_detail
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-1 col-md-1",
                                            children: ele.pd_pcomment_by == 2 || ele.pd_pcomment_by == 3 && /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/Avatar.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30
                                                }
                                            })
                                        })
                                    ]
                                }, i);
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-2 mt-3",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-1 col-md-1",
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "row",
                                            justifyContent: "flex-end",
                                            spacing: 3,
                                            children: /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/Avatar.png",
                                                roundedCircle: true,
                                                style: {
                                                    width: 50,
                                                    border: "4px solid #107BEF",
                                                    borderRadius: 30,
                                                    marginRight: 2
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-11 col-md-11",
                                        children: /*#__PURE__*/ _jsx("form", {
                                            onSubmit: onComment,
                                            style: {
                                                borderRadius: "6px",
                                                border: "1px solid #E5E5E5",
                                                padding: "10px 15px"
                                            },
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        className: "form-control me-3",
                                                        placeholder: "คอมเมนต์ . . .",
                                                        onChange: function(e) {
                                                            return setComment(e.target.value);
                                                        },
                                                        value: comment
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        value: comment,
                                                        type: "submit",
                                                        className: "btn btn-dg fs-10",
                                                        onClick: function(e) {
                                                            return setComment(e.currentTarget.value);
                                                        },
                                                        disabled: disable,
                                                        children: "คอมเมนต์"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ConfirmCancelModal, {
                show: modalcancel,
                onHide: function() {
                    return setModalcancel(false);
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: dataID ? null : "/product"
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            })
        ]
    });
}
function ConfirmCancelModal(props) {
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7 mb-2",
                                    children: "คุณต้องการยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7",
                                    children: "การสร้างรายการนี้ใช่หรือไม่"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-center pt-4 mt-3  btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/emps",
                                    className: "btn btn-st-3 mx-3 text-decoration-none",
                                    style: {
                                        width: "100px"
                                    },
                                    children: "ใช่"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 mx-3 ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: props.onHide,
                                    children: "ไม่ใช่"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
var ImageProductUpload = function(_param) {
    var isUpdate = _param.isUpdate, setFormData = _param.setFormData, setModalObj = _param.setModalObj, modalObj = _param.modalObj, setIsLoading = _param.setIsLoading, setImgPath = _param.setImgPath, imgPath = _param.imgPath, view = _param.view, props = _object_without_properties(_param, [
        "isUpdate",
        "setFormData",
        "setModalObj",
        "modalObj",
        "setIsLoading",
        "setImgPath",
        "imgPath",
        "view"
    ]);
    var dispatch = useAppDispatch();
    // const [imgData, setImgData] = useState(false);
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var handlePreviewimage = function() {
        var _ref = _async_to_generator(function(e) {
            var formData;
            return _ts_generator(this, function(_state) {
                if (e.target.files[0]) {
                    formData = new FormData();
                    formData.append("upload_tmp_product", e.target.files[0]);
                    dispatch(uploadProduct(formData, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                    setTextImg("image");
                }
                return [
                    2
                ];
            });
        });
        return function handlePreviewimage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadProductReducer = useAppSelector(function(state) {
        return state.uploadProductReducer;
    });
    useEffect(function() {
        if (textImg == "image") {
            setIsLoading(uploadProductReducer.isFetching);
            if (uploadProductReducer.data) {
                console.log("uploadProductReducer", uploadProductReducer.data.data);
                setImgPath(uploadProductReducer.data.data);
                setTextImg("");
            }
        }
    }, [
        uploadProductReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "align-items-center mb-2 border-dashed-1 text-center",
        onClick: function(e) {
            return document.getElementById("fileProductUpload").click();
        },
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: "file",
                name: "",
                className: "fileUpload hide-input",
                id: "fileProductUpload",
                accept: ".png, .jpg",
                onChange: function(e) {
                    handlePreviewimage(e);
                },
                disabled: view == "view" ? true : false
            }),
            imgPath ? /*#__PURE__*/ _jsx("img", {
                src: imgPath,
                style: {
                    width: 250
                }
            }) : /*#__PURE__*/ _jsxs("center", {
                className: "py-3",
                children: [
                    /*#__PURE__*/ _jsx(AddPhotoAlternateIcon, {
                        style: {
                            fontSize: 50,
                            color: "#B00412"
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-12",
                        style: {
                            color: "#B00412"
                        },
                        children: "ด้านหน้า"
                    })
                ]
            })
        ]
    });
};
var ImageGalleryUpload = function(_param) {
    var isUpdate = _param.isUpdate, galleryPath = _param.galleryPath, setGalleryPath = _param.setGalleryPath, setIsLoading = _param.setIsLoading, setModalObj = _param.setModalObj, modalObj = _param.modalObj, galleryDel = _param.galleryDel, setGalleryDel = _param.setGalleryDel, view = _param.view, disabled = _param.disabled, props = _object_without_properties(_param, [
        "isUpdate",
        "galleryPath",
        "setGalleryPath",
        "setIsLoading",
        "setModalObj",
        "modalObj",
        "galleryDel",
        "setGalleryDel",
        "view",
        "disabled"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), load = _useState1[0], setLoad = _useState1[1];
    var handlePreviewimage = function() {
        var _ref = _async_to_generator(function(e) {
            var formData;
            return _ts_generator(this, function(_state) {
                if (e.target.files[0]) {
                    formData = new FormData();
                    formData.append("upload_tmp_product", e.target.files[0]);
                    dispatch(uploadProduct(formData, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                    setTextImg("gallery");
                }
                return [
                    2
                ];
            });
        });
        return function handlePreviewimage(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadProductReducer = useAppSelector(function(state) {
        return state.uploadProductReducer;
    });
    useEffect(function() {
        if (textImg == "gallery") {
            setIsLoading(uploadProductReducer.isFetching);
            if (uploadProductReducer.data) {
                console.log("uploadProductReducer", uploadProductReducer.data.data);
                setGalleryPath(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: nanoid(),
                            pd_pimage_name: uploadProductReducer.data.data,
                            type: "create"
                        }
                    ]);
                });
                setTextImg("");
            }
        }
    }, [
        uploadProductReducer
    ]);
    var deleteDocument = function(removeId, item) {
        if (item.type == "update") {
            var del = {
                pd_pimage_id: item.pd_pimage_id
            };
            setGalleryDel(_to_consumable_array(galleryDel).concat([
                del
            ]));
        }
        setGalleryPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "row gx-xl-4 mt-3 ml-1",
        children: [
            galleryPath.map(function(item, index) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-2 col-md-3 mb-3",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: item.pd_pimage_name,
                                style: {
                                    width: 100,
                                    height: 100
                                }
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn  btn-delete-file-cross",
                                disabled: view == "view" ? true : false,
                                onClick: function() {
                                    return deleteDocument(item.id, item);
                                }
                            })
                        ]
                    })
                }, index);
            }),
            galleryPath.length < 8 && /*#__PURE__*/ _jsxs("div", {
                className: "col-xl-2 col-md-3 border-dashed-1",
                onClick: function(e) {
                    return document.getElementById("fileGalleryUpload").click();
                },
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "file",
                        name: "",
                        className: "fileUpload hide-input",
                        id: "fileGalleryUpload",
                        accept: ".png, .jpg",
                        onChange: function(e) {
                            handlePreviewimage(e);
                        },
                        disabled: view == "view" ? true : false
                    }),
                    /*#__PURE__*/ _jsxs("center", {
                        children: [
                            /*#__PURE__*/ _jsx(AddPhotoAlternateIcon, {
                                style: {
                                    fontSize: 50,
                                    color: "#B00412"
                                }
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "fs-12",
                                style: {
                                    color: "#B00412"
                                },
                                children: "เพิ่มรูปภาพ"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "fs-12",
                                style: {
                                    color: "#B00412"
                                },
                                children: [
                                    "(",
                                    galleryPath.length,
                                    "/8)"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var EvidenceDoc = function(_param) {
    var item = _param.item, index = _param.index, setFieldValue = _param.setFieldValue, values = _param.values, ondeleteDocument = _param.ondeleteDocument, setDocuments = _param.setDocuments, modalObj = _param.modalObj, setModalObj = _param.setModalObj, setIsLoading = _param.setIsLoading, evidenceType = _param.evidenceType, optionsProductFile = _param.optionsProductFile, disabled = _param.disabled, props = _object_without_properties(_param, [
        "item",
        "index",
        "setFieldValue",
        "values",
        "ondeleteDocument",
        "setDocuments",
        "modalObj",
        "setModalObj",
        "setIsLoading",
        "evidenceType",
        "optionsProductFile",
        "disabled"
    ]);
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), textImg = _useState[0], setTextImg = _useState[1];
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            console.log("e.target.files[0]", e.target.files[0]);
            var formData = new FormData();
            formData.append("upload_tmp_product", e.target.files[0]);
            dispatch(uploadProduct(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("doc");
        }
    };
    var uploadProductReducer = useAppSelector(function(state) {
        return state.uploadProductReducer;
    });
    useEffect(function() {
        if (textImg == "doc") {
            setIsLoading(uploadProductReducer.isFetching);
            if (uploadProductReducer.data) {
                console.log("uploadProductReducer", uploadProductReducer.data.data);
                setDocuments(function(prev) {
                    return prev.map(function(el) {
                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                            pd_pfile_name: uploadProductReducer.data.data
                        }) : el;
                    });
                });
                setTextImg("");
            }
        }
    }, [
        uploadProductReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3",
        children: [
            index > 0 && /*#__PURE__*/ _jsx("hr", {
                className: "my-2",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4 align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "fs-24 fw-bold tc-8",
                            children: [
                                index + 1,
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-xxl-3 col-xl-3 col-md-4 ",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "mb-2 form-st-3 pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "เอกสาร"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        placeholder: "เลือกเอกสาร",
                                        name: "pd_pfile_typeid",
                                        onChange: function(e) {
                                            setDocuments(function(prev) {
                                                return prev.map(function(el) {
                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                        pd_pfile_typeid: e.value
                                                    }) : el;
                                                });
                                            });
                                        },
                                        className: "w-100 select-st-1",
                                        options: optionsProductFile,
                                        value: optionsProductFile.filter(function(d) {
                                            return d.value == item.pd_pfile_typeid;
                                        }),
                                        isDisabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                type: "file",
                                name: "",
                                className: "fileUpload hide-input",
                                id: "fileUpload".concat(item.id),
                                accept: ".pdf",
                                onChange: function(e) {
                                    handlePreviewFile(e);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                width: "280px"
                            },
                            children: item.pd_pfile_name != null ? /*#__PURE__*/ _jsx(Link, {
                                to: item.pd_pfile_name,
                                target: "_blank",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "docfile",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "icon pdf",
                                        children: item.pd_pfile_name.substring(68)
                                    })
                                })
                            }) : /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn  btn-upload-file",
                                disabled: disabled,
                                onClick: function(e) {
                                    return document.getElementById("fileUpload".concat(item.id)).click();
                                },
                                children: "อัปโหลดไฟล์"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto",
                        children: /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn  btn-delete-file ",
                            disabled: disabled,
                            onClick: function(e) {
                                return ondeleteDocument(item.id, item);
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-auto"
                    })
                ]
            }),
            " "
        ]
    });
};
